export default __webpack_public_path__ + "static/media/dk_logo.79d48d50.png";